import { lazy } from 'react'

export const EmotionalEatingV1 = lazy(() => import('./EmotionalEatingV1'))
